import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { AbstractControl, Validator } from '@angular/forms';
import { AngularMyDatePickerDirective, IMyDateModel, IMyOptions } from '@nodro7/angular-mydatepicker';
import { Subject } from 'rxjs';

const VALIDATE_PARSE_ERROR = {
    dateParseError: {
        valid: false
    }
};

/**
 * Die Komponente stellt eine, in einem versteckten Eingabefeld, ngx-mydatepicker Direktive, das nach dem "init"
 * Datepicker geöffnet.
 * Es wird so gemacht, da ngx-mydatepicker nur als Direktive verwendbar. Als wir CDK Overlay benutzen, können wir
 * die Standardlösung nicht verwenden.
 */
@Component({
    selector: 'common-date-picker-overlay',
    template: `
        <input
                angular-mydatepicker
                class="commonDatepickerOverlayInput"
                #dp="angular-mydatepicker"
                (dateChanged)="onDateChange($event)"
                [options]="options"
                [(ngModel)]="innerModel"
                (calendarToggle)="onCalendarToggle($event)"
                [disabled]="disabled"/>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatePickerOverlayComponent implements AfterViewInit, Validator, OnDestroy {

    @Input() options: IMyOptions;

    @Output() close = new Subject<void>();

    @Output() touch = new Subject<void>();

    @Output() dateChange = new Subject<IMyDateModel>();

    @ViewChild('dp') dpDirective: AngularMyDatePickerDirective;

    innerModel: any;

    disabled: boolean = false;

    private isValid: boolean = true;

    @Input()
    set model(value: Date) {
        if (!value || !(value instanceof Date)) {
            return;
        }
        this.innerModel = {
            singleDate: {
                jsDate: value
            }
        };
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.dpDirective.openCalendar();
            this.dpDirective.registerOnTouched(() => this.touch.next());
        }, 0);
    }

    ngOnDestroy() {
        this.dateChange.complete();
    }

    validate(_: AbstractControl) {
        return this.isValid ? undefined : VALIDATE_PARSE_ERROR;
    }

    /**
     * 1 = calendar opened
     * 2 = calendar closed by date select
     * 3 = calendar closed by calendar button
     * 4 = calendar closed by outside click (document click)
     * 5 = calendar closed by ESC key
     */
    onCalendarToggle(event: number) {
        if (event !== 1) {
            this.close.next();
        }
    }

    onDateChange(date: IMyDateModel) {
        this.dateChange.next(date);
    }

    registerOnChange(fn: any) {
        this.dateChange.subscribe(x => fn(x));
    }

    setDisabledState(isDisabled: boolean) {
        this.disabled = isDisabled;
    }
}
